import React from "react";
import PlatformAnalyticsExperience from "./PlatformAnalyticsExperience";

/*
 * Mobile Analytics — served by the shared Platform Analytics experience. The
 * route, page title, report-link contract and topline data contract are
 * unchanged; the profile lives in
 * src/platformAnalytics/platformAnalyticsProfiles.js.
 *
 * The inventory-transparency module this page had before the migration is
 * preserved through the profile's distributionTransparencyChannel.
 *
 * No connector reports Mobile creative-level delivery, so the profile declares
 * no creativePerformancePlatformKey and the Creative Performance section
 * renders its governed unsupported state rather than an empty grid.
 */
export default function MobileAnalytics() {
  return <PlatformAnalyticsExperience platformKey="mobile" />;
}
